import { useState } from "react";
import { NavLink } from "react-router-dom";
import { MoreHorizontal } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { useAuth } from "@/context/AuthContext";
import { Avatar } from "@/components/Avatar";

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export const MoreMenu = ({ items }) => {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  return (
    <>
      <button onClick={() => setOpen(true)} data-testid="bottom-nav-more"
        className="flex flex-col items-center gap-0.5 text-[10px] font-semibold px-1 py-1 rounded-xl text-mm-muted">
        <MoreHorizontal size={21} />More
      </button>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="bottom" className="rounded-t-3xl max-h-[80vh] overflow-y-auto" data-testid="more-menu">
          <SheetHeader className="flex-row items-center gap-3 space-y-0 text-left">
            <Avatar url={user?.photo_url} name={user?.name} size={44} testId="more-menu-avatar" />
            <SheetTitle className="truncate">{user?.name}</SheetTitle>
          </SheetHeader>
          <div className="grid grid-cols-3 gap-2 mt-5">
            {items.map(({ to, label, icon: I }) => (
              <NavLink key={to} to={to} onClick={() => setOpen(false)} data-testid={`more-menu-${slug(label)}`}
                className={({ isActive }) => `flex flex-col items-center gap-1.5 p-3 rounded-2xl text-xs font-semibold transition-colors ${isActive ? "bg-mm-soft text-mm-primary" : "hover:bg-mm-soft"}`}>
                <I size={22} />{label}
              </NavLink>
            ))}
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
};
